import { Fragment } from 'react';

/** Marca en el texto las palabras buscadas. */
export function Resaltado({ texto, re }: { texto: string; re: RegExp | null }) {
  if (!re || !texto) return <>{texto}</>;
  const partes = texto.split(re);
  return (
    <>
      {partes.map((p, i) =>
        i % 2 === 1 ? <mark key={i}>{p}</mark> : <Fragment key={i}>{p}</Fragment>,
      )}
    </>
  );
}
